import {GridConfiguration, GridModel, GridRequest} from '../../shared/grid/grid.model';
import {DatePipe} from "@angular/common";
export class Member extends GridModel {
  id: number;
  fullName: string;
  acceptanceDate: Date;
  email: string;
  gender: string;
  genderString: string;
  dob: Date;
  industry: string;
  otherIndustry?: any;
  industryString: string;
  university?: any;
  employer?: any;
  employerOrUniversityString: string;
  jobRole: string;
  lookupInvitedById?: any;
  lookupInvitedByFullName?: any;
  membershipNumber: number;
  membershipType: string;
  membershipTypeString: string;
  membershipRenewalType?: any;
  expiryDate?: any;
  expiryDateString: string;
  invitesSent: number;
  invitesLeft: number;
  totalRevenue: number;
  totalRevenueString: string;
  venueRevenue: number;
  venueRevenueString: string;
  premiumRevenue: number;
  premiumRevenueString: string;
  loginPerMonth: number;
  visitsPerMonth: number;
  venueVisits: number;
}

export class MemberRequestModel extends GridRequest {

}
export class MemberGridConfiguration extends GridConfiguration {

  constructor() {
    super();
    this.columns = [
      {
        dataField: 'fullName',
        caption: 'Name',
      },
      {
        dataField: 'acceptanceDate',
        dataType: 'date',
        format: 'dd/MM/yyyy'
      },
      'email',
      {
        dataField: 'genderString',
        caption: 'Gender',
      },
      {
        dataField: 'doB',
        caption: 'DOB',
        dataType: 'date',
        format: 'dd/MM/yyyy'
      },
      'industry',
      {
        dataField: 'employerOrUniversityString',
        caption: 'Employer / University',
        allowSorting: false
      },
      {
        dataField: 'jobRole',
        caption: 'Role',
      },
      {
        dataField: 'lookupInvitedByFullName',
        caption: 'Invited By',
      },
      {
        dataField: 'membershipNumber',
        caption: 'Membership NO.',
      },
      {
        dataField: 'membershipTypeString',
        caption: 'MEMBERSHIP'

      },
      {
        dataField: 'expiryDate',
        caption: 'Expiry',
        dataType: 'date',
        calculateCellValue: function (data) {
          if (data.expiryDate) {
            if (data.isPayingMember) {
              return new DatePipe('en-GB').transform(data.expiryDate, 'dd/MM/yyyy') + ' - rolling';
            } else {
              return new DatePipe('en-GB').transform(data.expiryDate, 'dd/MM/yyyy');
            }
          }
        }
        // format: function (options, row) {
        //   console.log(row);
        //   if (options) {
        //     const date = new Date();
        //
        //     if (options.getUTCMonth() !== date.getUTCMonth()) {
        //       return new DatePipe('en-GB').transform(options, 'dd/MM/yyyy') + ' - rolling';
        //     }
        //     else {
        //       return new DatePipe('en-GB').transform(options, 'dd/MM/yyyy')
        //     }
        //   }
        // },
        // format: 'dd/MM/yyyy'
      },
      'invitesSent',
      'invitesLeft',
      {
        dataField: 'totalRevenueString',
        caption: 'Total Revenue'

      },
      {
        dataField: 'venueRevenueString',
        caption: 'Venue Revenue'

      },
      {
        dataField: 'premiumRevenueString',
        caption: 'Premium Revenue'

      },
      {
        dataField: 'loginPerMonth',
        caption: 'Login (P/M)',
        format: function (options) {
          if (options && options !== 0) {
            return (Math.round(parseFloat(options) * 100) / 100).toFixed(2);
          }
          return '0.00';
        }
      },
      {
        dataField: 'visitsPerMonth',
        caption: 'Visits (P/M)',
        format: function (options) {
          if (options && options !== 0) {
            return (Math.round(parseFloat(options) * 100) / 100).toFixed(2);
          }
          return '0.00';
        }
      },
      'venueVisits',
      {
        dataField: 'lastLogin',
        dataType: 'date',
        format: 'shortDateShortTime'
      },
    ];

    this.customSearch = [
      {
        fieldName: 'fullName',
        value: ''
      }
    ];

    this.columnAutoWidth = true;
    this.sorting = {mode: 'single'};

    this.selection.allowSelectAll = true;

  }

  mapGridRequest(gridRequest: GridRequest, loadOptions: any) {
    super.mapGridRequest(gridRequest, loadOptions);
    gridRequest.options.customSearch = this.customSearch;
  }
}
export class MemberDatabaseListModel {
  public id: number;
  public fullName: string;
  public acceptanceDate: Date;
  public email: string;
  public gender: string;
  public genderString: string;
  public doB: Date;
  public industry: string;
  public otherIndustry: string;
  public industryString: string;
  public university: string;
  public employer: string;
  public employerOrUniversityString: string;
  public jobRole: string;
  public lookupInvitedById: number;
  public lookupInvitedByFullName: string;
  public membershipNumber: number;
  public membershipType: string;
  public membershipTypeString: string;
  public membershipRenewalType: string;
  public expiryDate: Date;
  public expiryDateString: string;
  public invitesSent: number;
  public invitesLeft: number;
  public totalRevenue: number;
  public totalRevenueString: string;
  public venueRevenue: number;
  public venueRevenueString: string;
  public premiumRevenue: number;
  public premiumRevenueString: string;
  public loginPerMonth: number;
  public visitsPerMonth: number;
  public venueVisits: number;
  public isPayingMember: boolean;
  public lastLogin: Date;
}






// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/member-management/member-management.model.ts